import { render, staticRenderFns } from "./LangSelector.vue?vue&type=template&id=c9f5ed0e&scoped=true"
import script from "./LangSelector.vue?vue&type=script&lang=js"
export * from "./LangSelector.vue?vue&type=script&lang=js"
import style0 from "./LangSelector.vue?vue&type=style&index=0&id=c9f5ed0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f5ed0e",
  null
  
)

export default component.exports